<!--
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-08-12 16:46:05
 * @LastEditors: yd
 * @LastEditTime: 2020-09-08 14:31:52
 * @FilePath: \mrc-base-server-view\src\views\data-access-strategy\modules\dataAccessStrategy.vue
-->
<template>
  <div>
    <column-tabs></column-tabs>
  </div>
</template> 

<script>
import { required } from 'vuelidate/lib/validators'
import columnTabs from './columnTabs'
export default {
  components: { columnTabs },
  props: {

    cancelText: {
      type: String,
    },
  },
  data () {
    return {



    };
  },
  validations: {},
  computed: {},
  created () { },
  watch: {},
  mounted () { },

  methods: {
    success () {

    },
    cancel () {

    },
  },
};
</script>

<style scoped>
</style>
